
import { defineComponent } from "vue";
import { Alert } from "@/commons/types";
import Alerter from "./Alerter.vue";
import { UserSetPasswordSchema, UsersService } from "@/commons/client";

// Se hai i tipi del tuo store, importali e sostituisci 'any' qui.
type GenericRules = any;

export default defineComponent({
  name: "PasswordChange",

  components: {
    Alerter,
  },

  props: {
    userId: {
      type: Number,
      required: true,
    },
  },

  data(): {
    passwordChangeData: UserSetPasswordSchema;
    confirm: string;
    alerts: Alert[];
  } {
    return {
      // inizializzazione esplicita per evitare undefined
      passwordChangeData: {
        current_password: "",
        password: "",
      } as UserSetPasswordSchema,
      confirm: "",
      alerts: [],
    };
  },

  computed: {
    // Tipi di ritorno espliciti
    rules(): GenericRules {
      // Cast pragmatico per tipizzare $store
      const store = (this as any).$store as {
        state: { genericRules: GenericRules };
      };
      return store?.state?.genericRules ?? {};
    },

    maxCardWidth(): number {
      // Vuetify 2: this.$vuetify.breakpoint.name
      // Vuetify 3 sarebbe this.$vuetify.display.name
      const bpName =
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: compat Vuetify 2
        (this.$vuetify?.breakpoint?.name as string | undefined) ??
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: compat Vuetify 3
        (this.$vuetify?.display?.name as string | undefined);

      switch (bpName) {
        case "xs":
        case "sm":
          return 400;
        default:
          return 550;
      }
    },

    isValidData(): boolean {
      const d = this.passwordChangeData;
      return !!(
        d.current_password &&
        d.password &&
        this.confirm &&
        d.password === this.confirm
      );
    },
  },

  methods: {
    async updatePassword(): Promise<void> {
      if (!this.isValidData) {
        this.alerts.push({
          type: "error",
          text: "Le password non coincidono, o manca quella attuale",
        });
        return;
      }

      try {
        await UsersService.userChangePasswordV1UsersPkChangePasswordPatch(
          this.userId,
          this.passwordChangeData
        );
        this.alerts.push({
          type: "success",
          text: "Password aggiornata con successo",
        });
        // opzionale: pulizia campi
        this.passwordChangeData.current_password = "";
        this.passwordChangeData.password = "";
        this.confirm = "";
      } catch (err: unknown) {
        const message =
          (err as any)?.body?.detail ||
          (err as Error)?.message ||
          "Errore durante l'aggiornamento della password";
        this.alerts.push({
          type: "error",
          text: message,
        });
      }
    },
  },
});
